// GalleryRegen.jsx

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Step3 from "./Step3";

const defaultAiModel = {
  enabled: false,
  modelType: "",
  label: "",
  prompt: "",
};

const GalleryRegen = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navState = location.state || {};
  const {
    prev, // { age, channel, theme, style, bg_prompt, filter, customText }
    data,
    state: originalState,
    origin, // 여기: File일 수도, 이미지 문자열(dataURL/URL)일 수도 있음
    userCopy = "",
  } = navState;

  const [formData, setFormData] = useState({
    age: prev?.age || "",
    channel: prev?.channel || "",
    theme: prev?.theme || "",
    customText: userCopy || "",
    style: prev?.style || "",
    bg_prompt: prev?.bg_prompt || "",
    filter: prev?.filter || "",
    aiModel: prev?.aiModel || defaultAiModel,
  });

  // Step3에서 바로 표시할 수 있는 문자열 기반 미리보기 만들기
  const [originPreview, setOriginPreview] = useState(null);

  useEffect(() => {
    if (!origin || !data) {
      navigate(-1);
      return;
    }
  }, [origin, data, navigate]);

  useEffect(() => {
    let cancelled = false;

    // 1) origin이 이미 문자열이면 그대로 사용
    if (typeof origin === "string") {
      setOriginPreview(origin);
      return;
    }

    // 2) origin이 File이면 dataURL로 변환
    if (origin instanceof File) {
      const reader = new FileReader();
      reader.onload = () => {
        if (cancelled) return;
        setOriginPreview(reader.result);
      };
      reader.onerror = () => {
        if (cancelled) return;
        setOriginPreview(null);
      };
      reader.readAsDataURL(origin);
      return () => {
        cancelled = true;
      };
    }

    // 3) 그 외 값은 미리보기를 비움
    setOriginPreview(null);
    return () => {
      cancelled = true;
    };
  }, [origin]);

  if (!origin || !data) return null;

  const updateData = (patch) => {
    setFormData((prevData) => ({
      ...prevData,
      ...patch,
    }));
  };

  const handleBack = () => {
    navigate("/manual/marketing/gallery/result", {
      state: {
        state: originalState,
        data,
        origin,
        userCopy,
      },
    });
  };

  const handleSubmit = () => {
    const { age, channel, theme, style, bg_prompt, filter, customText, aiModel } = formData;

    if (!style) {
      alert("이미지 스타일을 선택해 주세요.");
      return;
    }

    navigate("/manual/marketing/camera/loading", {
      state: {
        imageFile: origin instanceof File ? origin : null,
        imageUri: typeof origin === "string" ? origin : null,
        channel,
        title: theme,
        age,
        style,
        bg_prompt,
        filter,
        aiModel,
        custom_menu: prev?.custom_menu,
        category: data.detail_category_name || data.category,
        store_name: data.store_name,
        road_name: data.road_name,
        district_name: data.district_name,
        main: data.main,
        temp: data.temp,
        data,
        customText: (customText || "").trim(),
      },
    });
  };

  return (
    <Step3
      data={formData}
      updateData={updateData}
      onBack={handleBack}
      onSubmit={handleSubmit}
      // 여기서는 문자열 기반 미리보기만 넘김
      image={{ imagePreview: originPreview }}
    />
  );
};

export default GalleryRegen;

